
import EditBase from "../EditBase"

class EditCone extends EditBase {

    constructor(options) {
        super(options);
    }

    checkRotatePoint() {
        return false;
    }

    initKeyPoint() {
        var keyPos = this.plot.attrPlot["edit_positions"]; //拿到关键点数组
        var e_pos = [];
        for (let i = 1; i < keyPos.length; i++) {
            var entity = this.createEnity();
            var point = this.createPoint(this.getDefaultStyle("point_Nor"));
            entity.show = false;
            entity.position = keyPos[i];
            entity.point = point;
            this.viewer.entities.add(entity);
            this.entities.push(entity);
            entity.attrPlot = {
                e_index: i,
                editGuid: this.editGuid,
                edit_keyFlag: true
            };
            e_pos.push(entity);
        }
        this.plot.attrPlot["edit_keyPos"] = e_pos; //实体
    }

    initCenterPoint() {
        var cartesian3 = this.plot.attrPlot["edit_positions"][0];
        var entity = this.createEnity();
        var point = this.createPoint(this.getDefaultStyle("point_Center"));
        entity.show = false;
        entity.position = cartesian3;
        entity.point = point;
        entity.attrPlot = {
            editGuid: this.editGuid,
            edit_centerFlag: true
        };
        this.viewer.entities.add(entity);
        this.entities.push(entity);
        this.plot.attrPlot["edit_center"] = entity; //实体
        this.plot.attrPlot['center_cartesian3'] = cartesian3;
    }

    initHeightPoint() {

        var entity = this.plot.attrPlot["edit_center"]; //实体
        var position = entity.position.getValue();

        var carto = Cesium.Cartographic.fromCartesian(position);
        var heightTerrain = this.viewer.scene.globe.getHeight(carto);

        var length = this.plot.cylinder.length.getValue();

        var heightPos = this.getPositionTranslation(position, { x: 0, y: 0, z: heightTerrain + length });
        var entity = this.createEnity();
        var point = this.createPoint(this.getDefaultStyle("point_height"));
        entity.show = false;
        entity.position = heightPos;
        entity.point = point;
        entity.attrPlot = {
            editGuid: this.editGuid,
            edit_heightFlag: true
        };
        this.viewer.entities.add(entity);
        this.entities.push(entity);
        this.plot.attrPlot["edit_height"] = entity; //实体
        this.plot.attrPlot["height_cartesian3"] = heightPos; //
        this.plot.attrPlot["length"] = heightTerrain + length;
    }
    updateHeightPoint() {

        var entity = this.plot.attrPlot["edit_height"]; //实体
        var height = 0;
        var center = this.plot.attrPlot['center_cartesian3'];
        var carto_center = Cesium.Cartographic.fromCartesian(center);
        var heightTerrain = this.viewer.scene.globe.getHeight(carto_center); //贴地高度
        var length = this.plot.cylinder.length.getValue();
        height += heightTerrain;
        height += length;
        var positionNew = Cesium.Cartesian3.fromRadians(carto_center.longitude, carto_center.latitude, height);
        entity.position.setValue(positionNew);
        this.plot.attrPlot["height_cartesian3"] = positionNew; //
    }

    updateCenter() {

    }

    translateAll(position) {
        super.translateAll(position);
        this.plot.position.setValue(position);
    }

    heightMoveAll(endPosition, startPosition) {
        var $this = this;
        var zOffset = new Cesium.Cartesian3();
        //改变高度垂直拖动
        var dy = endPosition.y - startPosition.y;

        var position = $this.heightPos.position.getValue();
        //获取该点的投影面
        var tangentPlane = new Cesium.EllipsoidTangentPlane(position);
        var scratchBoundingSphere = new Cesium.BoundingSphere(); //包围球体
        scratchBoundingSphere.center = position;
        scratchBoundingSphere.radius = 1;

        //获取像素大小-米
        var metersPerPixel = $this.viewer.scene.frameState.camera.getPixelSize(scratchBoundingSphere, $this.viewer.scene.frameState.context.drawingBufferWidth, $this.viewer.scene.frameState.context.drawingBufferHeight);
        var heightDiff = -dy * metersPerPixel;

        Cesium.Cartesian3.multiplyByScalar(tangentPlane.zAxis, heightDiff, zOffset);
        var newPosition = Cesium.Cartesian3.clone(position);
        Cesium.Cartesian3.add(position, zOffset, newPosition);

        $this.heightPos.position.setValue(newPosition);
        var carto = Cesium.Cartographic.fromCartesian(newPosition);
        $this.plot.attrPlot["length"] = carto.height;
    }

    initProperty() {
        var $this = this;
        var minR = 1;
        var positions = [];
        var default_length = this.plot.cylinder.length.getValue();
        var bottomRadiusProperty = new $this.Cesium.CallbackProperty(function () {
            positions = $this.plot.attrPlot["edit_positions"];
            var center = positions[0];
            var outline = positions[1];

            var r = Cesium.Cartesian3.distance(center, outline);
            return r ? r : r + minR;
        }, false);

        var lengthProperty = new $this.Cesium.CallbackProperty(function () {
            return $this.plot.attrPlot["length"] ? $this.plot.attrPlot["length"] : default_length;
        });

        this.plot.cylinder.length = lengthProperty;
        this.plot.cylinder.bottomRadius = bottomRadiusProperty;
    }

}

export default EditCone;